import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { environment } from '@environments/environment';

@Injectable()
export class AppTitleStrategy extends TitleStrategy {
  constructor(private readonly title: Title) {
    super();
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const routeTitle = this.buildTitle(snapshot)?.trim();
    const companyName = environment.company_name?.trim();
    const titleParts: string[] = [];

    if (routeTitle) {
      titleParts.push(routeTitle);
    }

    if (companyName && !routeTitle?.endsWith(companyName)) {
      titleParts.push(companyName);
    }

    if (titleParts.length > 0) {
      this.title.setTitle(titleParts.join(' - '));
    }
  }
}
